export class AmountSubType {
    id: number;
    amountTypeId: number;
    name: string;
}
